import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

$ = jQuery;

(function ($) {
    
    // Stop execution if this is the wizard page
    if (document.body.classList.contains("page-template-tpl-wizard")) return;

    $(function () {
        swiperSliders(Swiper);
    });
})(jQuery);

export function swiperSliders(Swiper) {
    const swiperSliders = document.querySelectorAll('.js-slider');

    swiperSliders.forEach(slider => {
        const viewportWidths = [0, 578, 992, 1200];
        const items = slider.querySelector('.js-sliderItems');
        let swiperInstance = null;

        // Count slides
        const totalSlides = slider.querySelectorAll('.swiper-slide').length;

        function getSlidesPerView(width) {
            const index = viewportWidths.filter(bp => width >= bp).length;

            // Determine max slides based on slider class
            const maxSlides = 3;

            // Ensure we do not exceed total slides or maxSlides
            return Math.min(index, totalSlides, maxSlides) || null;
        }

        function initSwiper(slidesPerView) {
            slider.classList.add('swiper-initialized', 'swiper-container');
            items.classList.add('swiper-wrapper', '-slider');
            const $isMobile = window.innerWidth < 1200 ? false : {
                nextEl: '.js-navArrowRight',
                prevEl: '.js-navArrowLeft',
            };

            return new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: slidesPerView,
                spaceBetween: 40,
                pagination: {
                    el: '.js-sliderPagination',
                    clickable: true,
                },
                navigation: $isMobile,
                on: {
                    slideChange(swiper) {
                        updateSlideOpacity(swiper);
                    },
                    resize(swiper) {
                        updateSlideOpacity(swiper);
                    },
                    afterInit(swiper) {
                        updateSlideOpacity(swiper);
                    }
                }
            });
        }

        function updateSlideOpacity(swiper) {
            const { activeIndex, params } = swiper;
            const visibleCount = params.slidesPerView;

            swiper.slides.forEach((slide, index) => {
                if (index >= activeIndex && index < activeIndex + visibleCount) {
                    slide.style.opacity = '1';
                } else {
                    slide.style.opacity = '0';
                }
                slide.style.transition = 'opacity 300ms';
            });
        }

        function handleResize() {
            const width = window.innerWidth;

            // If slider has -mobile class, don't initialize above 1200px
            if (slider.classList.contains('-mobile') && width > 1200) {
                resizeDestroySlider();
                return;
            }

            const slidesPerView = getSlidesPerView(width);

            if (slidesPerView === null) {
                resizeDestroySlider();
            } else {
                if (!swiperInstance) {
                    swiperInstance = initSwiper(slidesPerView);
                } else if (swiperInstance.params) {
                    swiperInstance.params.slidesPerView = slidesPerView;
                    swiperInstance.update();
                    updateSlideOpacity(swiperInstance);
                }
            }
        }

        function resizeDestroySlider() {
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null; // reset outer variable
                slider.classList.remove('swiper-initialized', 'swiper-container');
                items.classList.remove('swiper-wrapper', '-slider');
            }
        }

        window.addEventListener('resize', handleResize);
        window.addEventListener('load', handleResize);
    });
}